import { useParams } from "react-router-dom";
import { Cards, Crumbs, Cta } from "../components/Bits";
import { Head } from "../components/Head";
import { useData } from "../lib/data";
import { origin } from "../lib/util";
import NotFound from "./NotFound";

export default function Category() {
  const { key } = useParams();
  const { CBY, BY, GBY } = useData();
  const c = CBY[key];
  if (!c) return <NotFound />;
  const rs = c.recipe_slugs.map(s => BY[s]);
  const g = c.guide && GBY[c.guide];
  const ld = [{ "@context": "https://schema.org", "@type": "ItemList", name: c.h1, itemListElement: rs.map((r, i) => (
    { "@type": "ListItem", position: i + 1, name: r.title, url: `${origin()}/opskrifter/${r.slug}/` })) }];
  return (
    <>
      <Head title={c.h1} path={`kategori/${c.key}/`} ld={ld} desc={`${c.intro.split(".")[0]}. ${rs.length} opskrifter med pris, tid og fremgangsmåde.`} />
      <Crumbs trail={[["opskrifter/", "Opskrifter"], [null, c.name]]} />
      <div className="wrap">
        <div className="ptop"><h1 data-testid="category-title">{c.h1}</h1><p className="lead">{c.intro}</p></div>
        <p className="count" data-testid="category-count">{rs.length} opskrifter. Gennemsnitlig pris: ca. {c.avg_price} kr. pr. person.</p>
        <Cards rs={rs} />
        {g && <div className="note">Læs også: <a href={`/guides/${g.slug}/`}>{g.title}</a></div>}
        <div className="blk"><Cta h="Gør det til en madplan" p="Vælg dine favoritter, og få en samlet indkøbsliste." /></div>
      </div>
    </>
  );
}
